import { render, staticRenderFns } from "./RelatorioPacienteGeral.vue?vue&type=template&id=08adbd48&scoped=true"
import script from "./RelatorioPacienteGeral.vue?vue&type=script&lang=js"
export * from "./RelatorioPacienteGeral.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPacienteGeral.vue?vue&type=style&index=0&id=08adbd48&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08adbd48",
  null
  
)

export default component.exports